<!-- 发票信息管理 -->
<template>
  <div>
    <div class="back">
      <span class="back-btn" @click="$router.go(-1)"><a-icon type="left" />返回</span>
    </div>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      class="invoice-form"
      >
      <a-form-model-item label="发票抬头" prop="invoiceTitle" v-if="form.titleType == 0">
        <span>个人</span>
      </a-form-model-item>
      <a-form-model-item label="抬头类型" prop="titleType">
        <a-radio-group v-model="form.titleType" @change="handleChangeTitleType">
          <a-radio :value="0">个人</a-radio>
          <a-radio :value="1">企业</a-radio>
          <a-radio :value="2">事业单位</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="发票抬头" prop="invoiceTitle" v-if="form.titleType != 0">
        <a-input v-model="form.invoiceTitle" class="w240"/>
      </a-form-model-item>
      <a-form-model-item prop="invoiceType">
        <template slot="label">
          <a-tooltip placement="top">
            <template slot="title">
              <span>该发票类型仅为默认的类型。实际发票类型以用户在进行发票申请时的选择为准。</span>
            </template>
            <span class="default-type">默认发票类型</span>
          </a-tooltip>
        </template>
        <div v-if="form.titleType == 0">增值税普通发票 
          <a-tooltip placement="top">
            <template slot="title">
              <span>增值税普通发票开给小规模纳税人或者开票资料不齐全的购买人，购买人取得后不可以进行进项税额抵扣。若您还有疑问，建议联系贵司财务确认后再提交开票需求。</span>
            </template>
            <a-icon type="question-circle" />
          </a-tooltip>
        </div>
        <a-radio-group v-model="form.invoiceType" v-if="form.titleType != 0">
          <a-radio :value="0">增值税普通发票 
            <a-tooltip placement="top">
              <template slot="title">
                <span>增值税普通发票开给小规模纳税人或者开票资料不齐全的购买人，购买人取得后不可以进行进项税额抵扣。若您还有疑问，建议联系贵司财务确认后再提交开票需求。</span>
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </a-radio>
          <a-radio :value="1" :disabled="form.titleType == 2">增值税专用发票
            <a-tooltip placement="top">
              <template slot="title">
                <span>增值税专用发票开给一般纳税人，申请时需要提供公司名称、税号、地址电话、开户行名称及账号，一般纳税人批复，购买人取得后可以进行进项税额抵扣。增值税专用发票只能开具纸质发票。若您还有疑问，建议联系贵司财务确认后再提交开票需求。</span>
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <div v-if="form.titleType != 0">
        <a-form-model-item label="统一社会信用代码" prop="taxNumber" :rules="[{ required: form.titleType == 1, message: '统一社会信用代码不能为空', trigger: 'change' }]">
          <a-input v-model="form.taxNumber" class="w240"/>
          <div class="tips">请与贵公司财务人员核实后，仔细填写准确的三证合一后的统一社会信用代码，否则将影响后续发票的正常使用</div>
        </a-form-model-item>
        <a-form-model-item label="营业执照" prop="bizLicenseUrl" :rules="[{ required: form.titleType == 1, message: '请上传营业执照', trigger: 'change' }]">
          <a-upload
            name="file"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            action="/api/invoice/file/upload"
            :headers=" {
              'Access-Cookie': $store.state.token,
            }"
            :before-upload="beforeUpload"
            @change="handleChange"
          >
            <img v-if="form.bizLicenseUrl" :src="form.bizLicenseUrl" alt="avatar" />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                上传
              </div>
            </div>
          </a-upload>
        </a-form-model-item>
        
        <a-form-model-item label="开户银行名称" prop="bankName" :rules="[{ required: form.invoiceType == 1, message: '开户银行名称不能为空', trigger: 'change' }]">
          <a-input v-model="form.bankName" class="w240"/>
        </a-form-model-item>
        <a-form-model-item label="基本开户账号" prop="bankAccount" :rules="[{ required: form.invoiceType == 1, message: '基本开户银行名称不能为空', trigger: 'change' }]">
          <a-input v-model="form.bankAccount" class="w240"/>
        </a-form-model-item>
        <a-form-model-item label="注册场所地址" prop="companyAddress" :rules="[{ required: form.invoiceType == 1, message: '注册场所地址不能为空', trigger: 'change' }]">
          <a-input v-model="form.companyAddress" class="w240"/>
        </a-form-model-item>
        <a-form-model-item
          label="注册固定电话"
          prop="companyPhone" 
          :rules="[
            { required: form.invoiceType == 1, message: '注册固定电话不能为空', trigger: 'change' },
            { min: 5, max: 17, message: '注册固定电话长度为5至17位', trigger: 'blur' }
          ]">
          <a-input v-model="form.companyPhone" class="w240"/>
        </a-form-model-item>
      </div>
      <a-form-model-item label="手机号" prop="receivePhone">
        <a-input v-model="form.receivePhone" class="w240"/>
      </a-form-model-item>
      <a-form-model-item label="邮箱" prop="receiveEmail">
        <a-input v-model="form.receiveEmail" class="w240"/>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button type="primary" @click="onSubmit">提交</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
  
</template>
<script>
import { queryInvoiceInfo, addOrUpdateInvoice } from '@/api/api'
const TEL_REG = /^\d{3,4}-\d{7,8}$/
export default {
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      other: '',
      form: {
        invoiceTitle: '个人', // 发票抬头
        titleType: 0, // 抬头类型
        invoiceType: 0, // 发票类型
        taxNumber: '', // 统一社会信用代码
        bankName: '', // 开户银行名称
        bankAccount: '', // 基本开户账号
        companyAddress: '', // 注册场所地址
        companyPhone: '', // 注册固定电话
        bizLicenseUrl: '', // 营业执照
        receivePhone: '',
        receiveEmail: '',
      },
      
      loading: false,

      titleTypeList: [
        {
          key: 0,
          value: '个人'
        },
        {
          key: 1,
          value: '企业'
        },
        {
          key: 2,
          value: '事业单位'
        },
      ],

      rules: {
        invoiceTitle: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' },
          // { pattern: /^([0-9]+[a-zA-Z]+|[a-zA-Z]+[0-9]+)[0-9a-zA-Z]*$|^[\u4e00-\u9fa5]+$/, message: '该抬头不合规，不支持全英文/数字的抬头名称', trigger: 'change'}
        ],
        invoiceType: [{ required: true, message: '请选择发票类型', trigger: 'change' }],
        titleType: [{ required: true, trigger: 'change' }],
      },
    };
  },
  methods: {

    getInvoiceInfo() {
      queryInvoiceInfo().then(({response}) => {
        this.form = response
      })
    },

    // 选择发票抬头类型
    handleChangeTitleType() {
      if (this.form.titleType == 0) {
        this.form.invoiceTitle = '个人'
      } else if (this.form.titleType == 1) {
        this.form.invoiceTitle = ''
      } else if (this.form.titleType == 2) {
        this.form.invoiceTitle = ''
        this.form.invoiceType = 0
      }

      this.$refs.ruleForm.clearValidate()
    },

    // 上传之前
    beforeUpload() {

    },

    // 上传状态
    handleChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);

        this.form.bizLicenseUrl = window.location.origin + info.file.response.response.fileUrl
      }
    },

    // 提交数据
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const para = {
            id: this.form.id,
            titleType: this.form.titleType,
            invoiceTitle: this.form.invoiceTitle,
            invoiceType: this.form.invoiceType,
            taxNumber: this.form.invoiceTitle,
            bankName: this.form.bankName,
            bankAccount: this.form.bankAccount,
            companyAddress: this.form.companyAddress,
            companyPhone: this.form.companyPhone,
            bizLicenseUrl: this.form.bizLicenseUrl,
            receivePhone: this.form.receivePhone,
            receiveEmail: this.form.receiveEmail
          }

          addOrUpdateInvoice(para).then(res => {
            
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },

  created() {
    this.getInvoiceInfo()
  }
};
</script>

<style lang="less" scoped>
  .back {
    background: #fff;
    .back-btn {
      padding: 0 20px;
      display: inline-block;
      line-height: 40px;
      cursor: pointer;
    }
  }
  .invoice-form {
    padding: 28px 0;
    background: #fff;
    .default-type {
      cursor: pointer;
      border-bottom: 1px dashed rgb(61, 61, 61);
    }
    .tips {
      line-height: 20px;
      font-size: 12px;
      color: rgb(153, 153, 153);
    }
  }
</style>
